export const DEFAULT_FILTERS = {};

export const ACCESS_RIGHTS_RESOURCE = 'accessRights';
export const ON_PREMISE_ACCESS_RIGHTS_RESOURCE = 'onPremiseAccessRights';
export const INFINITE_SCROLL = { loader: 'blocked' };
export const FILTER_SETTINGS = {
  defaults: DEFAULT_FILTERS,
  debounced: [],
};

export const DEFAULT_SORT = {};

export const ACCESS_RIGHTS_ACTIONS = {
  EDIT: 'edit',
  NEW: 'new',
  DETAILS: 'details',
};
